import { getExistingFilterDataFirstValue } from '../../utils';
import FormSelect from '../FormSelect';
import React from 'react';
import { css } from '@linaria/core';
import { trackFilterSelection } from '../../utils/dataLayer';

const optionCount = css`
  border-radius: 5px;
  padding: 3px 5px;
  font-size: 16px;
  background: #d1e1fb;
  color: #1a1a1a;
  margin-left: 10px;
`;

const optionIndent = css`
  padding-left: 10px;
`;

const optionBase = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export default function DropDownFilters(props) {
  const fieldId = props.fieldId;
  const options = props.options;
  const filters = props.filters;
  const isLastElement = props.isLastElement;

  let existingFilterValue = getExistingFilterDataFirstValue(fieldId, filters);

  if (!existingFilterValue) {
    existingFilterValue = '';
  }

  const handleChange = option => {
    if (!option) {
      props.removeFilter(fieldId);
      return;
    }
    props.setFilter(fieldId, option.value);
    trackFilterSelection(fieldId, option.value);
  };

  const selectLabel = option => {
    return option.name ? option.name : option.value;
  };

  const processOptions = options => {
    return options.map(option => ({
      label: (
        <span
          className={`${optionBase} ${option.level === 1 ? optionIndent : ''}`}
        >
          <span>{selectLabel(option)}</span>
          <span className={optionCount}>{option.count.toLocaleString()}</span>
        </span>
      ),
      value: option.value,
      isNested: option.level === 1,
    }));
  };

  return (
    <FormSelect
      disabled={options.length === 0}
      formHint={props.formHint}
      id={props.id}
      isLastElement={isLastElement}
      label={props.label}
      onChange={o => handleChange(o)}
      options={processOptions(options)}
      value={existingFilterValue}
    />
  );
}
